export const buildVersion = import.meta.env?.VITE_RELEASE_VERSION;
